import { useState } from "react";

function PaymentDetails() {
  const [cards, setCards] = useState([
    {
      id: 1,
      cardType: "Visa",
      cardNumber: "**** **** **** 1234",
      expDate: "12/23",
    },
    {
      id: 2,
      cardType: "MasterCard",
      cardNumber: "**** **** **** 5678",
      expDate: "06/24",
    },
  ]);

  const handleAddCard = () => {
    // Code to add a new payment card
  };

  const handleRemoveCard = (id) => {
    // Code to remove the payment card with the given id
  };

  return (
    <div className="py-4">
      <h2 className="font-bold text-gray-700 text-lg mb-4">Payment Details</h2>
      <div className="flex items-center mb-4">
        <h3 className="font-bold text-gray-600 mr-2">Payment Cards</h3>
        <button
          className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-1 px-2 rounded"
          onClick={handleAddCard}
        >
          Add Card
        </button>
      </div>
      {cards.map((card) => (
        <div className="border border-gray-300 rounded-lg p-4 mb-2" key={card.id}>
          <div className="flex justify-between mb-2">
            <p className="text-gray-600">{card.cardType}</p>
            <button
              className="text-red-600 font-bold"
              onClick={() => handleRemoveCard(card.id)}
            >
              Remove
            </button>
          </div>
          <p className="text-gray-600">{card.cardNumber}</p>
          <p className="text-gray-600">{card.expDate}</p>
        </div>
      ))}
      <button className="text-white bg-black hover:scale-[1.05] transition-all font-semibold py-1 px-2 rounded">
        Pay with New Card
      </button>
    </div>
  );
}

export default PaymentDetails;
